

import { Component, Mixins } from 'vue-property-decorator';
import { DevicesModule } from '~/store/modules/devices';
import PopupMixin from '~common-mixins/PopupMixin';
import { LoadingModule } from '~common-store/modules/loading';
import apiService from '~/services/api.service';
import { NotificationsModule } from '~common-store/modules/notifications';

@Component
export default class OperationAssociateUser extends Mixins(PopupMixin) {
    userMail = '';

    get currentGatewayId() {
        return DevicesModule.currentGatewayId;
    }

    get isEmailValid() {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.userMail);
    }

    async associateUser() {
        LoadingModule.showLoading(true);
        try {
            await apiService.associateuser({
                device_id: this.currentGatewayId,
                mail: this.userMail,
            });
            NotificationsModule.pushNotification({
                type: 'success',
                title: 'Device properly associated',
                text: 'Reloading',
                duration: 5000,
            });
            // wait 5 seconds before reloading
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        } catch (error) {
            NotificationsModule.pushNotification({
                type: 'error',
                title: 'Error while associating device',
                duration: 5000,
            });
            LoadingModule.showLoading(false);
        }
    }
}
